import firebase from 'firebase'
// import firestore from 'firebase/firestore'
// const firebase = require('firebase')
// const firestore = require('firebase/firestore')

var config = {
    apiKey: "AIzaSyDqUFKNKXxImfMXct9Rlu6U_jbQ_F66blY",
    authDomain: "vaboo-admin.firebaseapp.com",
    databaseURL: "https://vaboo-admin.firebaseio.com",
    projectId: "vaboo-admin",
    storageBucket: "vaboo-admin.appspot.com",
    messagingSenderId: "826995227185"
};

const firebaseApp = firebase.initializeApp(config)

export default firebaseApp
// export var storage = firebase.storage()